export enum Page {
  sitemap = '/sitemap',
  wishlist = '/wishlist',
  localDealers = '/localDealers',
  search = '/search',
  category = '/category',
  contentful = '/contentful',
  home = '/home',
}
